module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CT",
    attrs: {
      "id": "_idParaDest-6"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CONTitle ParaOverride-6"
  }, [_c('a', {
    attrs: {
      "href": "#/V4481_eBook6#_idTextAnchor000"
    }
  }, [_vm._v("Revenge")])]), _vm._v(" "), _c('p', {
    staticClass: "CONTitle"
  }, [_c('span', {
    attrs: {
      "href": "#/V4481_eBook11#_idTextAnchor001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Man Who Gave Up His Name")])]), _vm._v(" "), _c('p', {
    staticClass: "CONTitle"
  }, [_c('span', {
    attrs: {
      "href": "#/V4481_eBook17#_idTextAnchor002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Legends of the Fall")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11ea20e9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/V4481_eBook5.vue
// module id = 78
// module chunks = 0